import React from 'react';
import { useInView } from '../hooks/useInView';
import { BookOpen, Dumbbell, Heart, Accessibility, Zap, BarChart3 } from 'lucide-react';
export function ValueStackSection() {
  const {
    ref,
    isVisible
  } = useInView();
  const volumes = [{
    icon: <BookOpen className="w-6 h-6 text-cta" strokeWidth={1.5} data-id="element-125" />,
    title: 'Vol 1: Pilates Posturale Avanzato',
    desc: 'Protocolli per Cervicalgia, Lombalgia e Scoliosi.'
  }, {
    icon: <Dumbbell className="w-6 h-6 text-cta" strokeWidth={1.5} data-id="element-126" />,
    title: 'Vol 2: Piccoli Attrezzi: Guida Completa',
    desc: '100+ varianti con Magic Circle, Bande, Roller e Soft Ball.'
  }, {
    icon: <Heart className="w-6 h-6 text-cta" strokeWidth={1.5} data-id="element-127" />,
    title: 'Vol 3: Protocolli per la Terza Età',
    desc: 'Il manuale per la "Silver Generation", il target più fedele.'
  }, {
    icon: <Accessibility className="w-6 h-6 text-cta" strokeWidth={1.5} data-id="element-128" />,
    title: 'Vol 4: Inclusione e Adattamenti (BES/DSA)',
    desc: 'Esercizi adattati per bisogni educativi speciali.'
  }, {
    icon: <Zap className="w-6 h-6 text-cta" strokeWidth={1.5} data-id="element-129" />,
    title: 'Vol 5: Pilates Dinamico e Flow',
    desc: 'Sequenze ad alta intensità per sportivi e clienti fit.'
  }, {
    icon: <BarChart3 className="w-6 h-6 text-cta" strokeWidth={1.5} data-id="element-130" />,
    title: 'Vol 6: Business per Istruttori',
    desc: 'Gestisci uno studio che fattura regolarmente.'
  }];
  return <section className="bg-white py-12 md:py-20 px-4 border-t border-gray-100" data-id="element-131">
      <div className="max-w-5xl mx-auto" data-id="element-132">
        <div ref={ref} className={`fade-in ${isVisible ? 'is-visible' : ''}`} data-id="element-133">
          <h2 className="font-heading text-xl md:text-4xl text-headline font-extrabold text-center mb-10 md:mb-16 tracking-tight" data-id="element-134">
            La Soluzione: 6 Manuali Tecnici
          </h2>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6" data-id="element-135">
            {volumes.map((vol, idx) => <div key={idx} className="bg-white rounded-brand p-5 md:p-6 shadow-soft border border-gray-100" data-id="element-136">
                <div className="flex items-center gap-3 mb-3" data-id="element-137">
                  <div className="w-10 h-10 bg-cta/5 rounded-brand flex items-center justify-center flex-shrink-0" data-id="element-138">
                    {vol.icon}
                  </div>
                </div>
                <h3 className="font-heading font-bold text-headline text-sm md:text-base mb-1.5 leading-snug" data-id="element-139">
                  {vol.title}
                </h3>
                <p className="text-body text-xs md:text-sm font-light leading-relaxed mb-4" data-id="element-140">
                  {vol.desc}
                </p>
                <div className="mt-auto pt-3 border-t border-gray-100 flex items-center justify-between text-xs" data-id="element-141">
                  <span className="text-body/60" data-id="element-142">
                    Valore individuale:{' '}
                    <span className="line-through" data-id="element-143">€47</span>
                  </span>
                  <span className="text-cta font-bold" data-id="element-144">Incluso</span>
                </div>
              </div>)}
          </div>
        </div>
      </div>
    </section>;
}